export class cMongoTranslator {
  private _mongoOperators :Map<string,string>;

  constructor() {
    this._mongoOperators = new Map();
    this._mongoOperators.set("|", "$or");
    this._mongoOperators.set("&", "$and");
    this._mongoOperators.set("<>", "$not");
  }

  public async createQuery(whereObject: any, logicalOperator = "&") {
    const query: any = {};
    if (Object.keys(whereObject).length !== 0 && logicalOperator) {
      const operator = this._mongoOperators.get(logicalOperator) as string
      query[operator] = [];
      const whereKeys = Object.keys(whereObject);
      
      whereKeys.forEach((key) => {
        const tempObject = {};
        if (typeof(whereObject[key]) === "string")
          tempObject[key] = {"$regex": whereObject[key], "$options": "i"};
        else
          tempObject[key] = whereObject[key];
        query[operator].push(tempObject);
      });
      
    }
    return JSON.stringify(query);
  }
} 